import { Link } from 'react-router-dom';
import { CompanyConfig } from '../../company.config';

export const HeaderComponent = () => {
  return (
    <header>
      <section className="container-fluid container-xl">
        <div className="row">
          <div className="col-12 col-md-5 text-center text-md-start">
            <img alt={`${CompanyConfig.name} logo`} id="logo" src={CompanyConfig.logoUrl} />
          </div>
          <div className="col-12 col-md-7 text-center text-md-end flex">
            <div>
              <Link
                className="bttn mr-1"
                title={`Call ${CompanyConfig.name}`}
                to={`tel:${CompanyConfig.phone}`}
                target="_blank"
                tabIndex={-1}
              >
                Call Us
              </Link>
              <Link
                className="bttn"
                title={`${CompanyConfig.name} website`}
                to={CompanyConfig.website}
                target="_blank"
                data-discover="true"
                tabIndex={-1}
              >
                Homepage
              </Link>
            </div>
          </div>
        </div>
      </section>
    </header>
  );
};
export default HeaderComponent;
